import { useState } from "react";
import AppCard from "../components/shared/AppCard";
import Seo from "../components/shared/Seo";
import NoticeBanner from "../components/ui/NoticeBanner";
import EmptyState from "../components/ui/EmptyState";
import InputField from "../components/ui/InputField";
import LoadingState from "../components/ui/LoadingState";
import SectionHeading from "../components/ui/SectionHeading";
import useContentResource from "../hooks/useContentResource";
import { createCollectionPageSchema } from "../seo/schema";
import { buildCanonicalUrl } from "../seo/siteConfig";
import { getApps } from "../services/content/apps.service";

function MyAppShopPage() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedPlatform, setSelectedPlatform] = useState("All");
  const appsState = useContentResource(
    ({ signal }) => getApps({ signal, limit: 24 }),
    []
  );
  const apps = appsState.data || [];
  const categoryOptions = ["All", ...new Set(apps.map((item) => item.category))];
  const platformOptions = ["All", ...new Set(apps.flatMap((item) => item.platform))];

  const filteredApps = apps.filter((app) => {
    const matchesSearch =
      app.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      app.summary.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory =
      selectedCategory === "All" || app.category === selectedCategory;
    const matchesPlatform =
      selectedPlatform === "All" || app.platform.includes(selectedPlatform);

    return matchesSearch && matchesCategory && matchesPlatform;
  });

  return (
    <div className="page-stack">
      <Seo
        title="MyAppShop"
        description="iOS, Android ve Web uygulamalarini filtrelenebilir, aranabilir ve detay sayfalarina acilan premium bir vitrinle kesfedin."
        path="/myappshop"
        schema={[
          createCollectionPageSchema({
            title: "MyAppShop",
            description:
              "iOS, Android ve Web uygulamalarini listeleyen proje vitrini.",
            url: buildCanonicalUrl("/myappshop"),
            itemUrls: apps.map((item) =>
              buildCanonicalUrl(`/myappshop/${item.slug}`)
            ),
          }),
        ]}
        keywords={[
          "uygulama vitrini",
          "iOS uygulama",
          "web uygulama",
          "Android uygulama",
        ]}
      />
      {appsState.usedFallback ? (
        <NoticeBanner>
          MyAppShop verileri su anda local fallback kaynagindan geliyor.
          WordPress tarafinda custom post type hazir oldugunda otomatik olarak
          API verisi kullanilacak.
        </NoticeBanner>
      ) : null}
      <section className="glass-panel page-hero">
        <SectionHeading
          eyebrow="MyAppShop"
          title="iOS, Android ve Web urunleri icin premium bir uygulama vitrini"
          description="Filtrelenebilir, aranabilir ve detay sayfasina acilan bir listeleme altyapisi ile urunlerinizi profesyonelce sunabilirsiniz."
        />
      </section>

      <section className="content-section">
        <div className="glass-panel toolbar-panel">
          <InputField
            label="Ara"
            placeholder="Uygulama, kategori veya ozet ara"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
          />

          <div className="filter-group">
            <p className="filter-label">Kategori</p>
            <div className="tag-row">
              {categoryOptions.map((item) => (
                <button
                  key={item}
                  className={`tag-pill filter-pill${
                    selectedCategory === item ? " filter-pill-active" : ""
                  }`}
                  type="button"
                  onClick={() => setSelectedCategory(item)}
                >
                  {item}
                </button>
              ))}
            </div>
          </div>

          <div className="filter-group">
            <p className="filter-label">Platform</p>
            <div className="tag-row">
              {platformOptions.map((item) => (
                <button
                  key={item}
                  className={`tag-pill filter-pill${
                    selectedPlatform === item ? " filter-pill-active" : ""
                  }`}
                  type="button"
                  onClick={() => setSelectedPlatform(item)}
                >
                  {item}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="content-section">
        {appsState.loading ? (
          <LoadingState title="Uygulamalar yukleniyor..." />
        ) : filteredApps.length ? (
          <div className="card-grid card-grid-two">
            {filteredApps.map((app) => (
              <AppCard key={app.id} app={app} />
            ))}
          </div>
        ) : (
          <EmptyState
            title="Eslesen uygulama bulunamadi"
            description="Arama ya da filtreleri degistirerek yeni sonuc deneyebilirsiniz."
          />
        )}
      </section>
    </div>
  );
}

export default MyAppShopPage;
